import { render, staticRenderFns } from "./delete-user.vue?vue&type=template&id=04e9f266"
import script from "./delete-user.vue?vue&type=script&lang=js"
export * from "./delete-user.vue?vue&type=script&lang=js"
import style0 from "./delete-user.vue?vue&type=style&index=0&id=04e9f266&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports